import { restApiRP } from "@plannel/services/utils/rest-api";
import ResponseUtil from "@plannel/pages/utils/response-util";

const user = JSON.parse(localStorage.getItem("user"));
const getRpPolicies = (params) => {
  return restApiRP.post("/api/replenishment-plan", params);
};

const getAllForCSV = params => {
  return restApiRP.post("/api/replenishment-plan/csv", params);
};

const createVersion = data => {
  return restApiRP.post("/api/replenishment-plan/create-version", data);
};

const runRp = data => {
  return restApiRP.post("/api/replenishment-plan/run-rp", data);
}

const removeVersion = data => {
  return restApiRP.post("/api/replenishment-plan/remove-version", data);
}

const upsert = data => {
  return restApiRP.post("/api/replenishment-plan/save", data);
};

const bulkValueUpdate = data => {
  return restApiRP.post("/api/replenishment-plan/bulk-value-update", data);
}

const psiUpdate = data => {
  return restApiRP.post("/api/replenishment-plan/psi-update", data);
}

const getAllForRawCSV = params => {
  return fetch(`/api/replenishment-plan/raw-csv`, {
    body: ResponseUtil.getExportParamsForPost(params),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-tenant-id": user.tenantId,
      Authorization: `${user.type} ${user.accessToken}`,
      "x-module-name": "RP"
    }
  });
};

const runRpService = {
  getRpPolicies,
  getAllForCSV,
  createVersion,
  runRp,
  removeVersion,
  upsert,
  bulkValueUpdate,
  psiUpdate,
  getAllForRawCSV
};

export default runRpService;